import Button from 'components/Button/index'
import InfoCards from 'components/InfoCards'
import { Form } from 'components/UIComponents/FormStyles'
import PlusIcon from 'components/icons/PlusIcon'
import AddUserDrawer from 'modules/Users/Partials/AddUserDrawer'
import UsersFilter from 'modules/Users/Partials/UsersFilter'
import UsersTable from 'modules/Users/Partials/UsersTable'
import { getCardData } from 'modules/Users/Partials/constant'
import {
  CardRow,
  PaddedDiv,
  SectionWrapper,
  TopHeader,
  TopHeading,
} from 'modules/Users/Style/style'
import React, { useEffect, useRef, useState } from 'react'
import {
  permittedCruds,
  permittedEventCruds,
} from '../../utils/permissionsValidation'

const Users = ({
  getUserMetrics,
  getUserList,
  userMetrics,
  userList,
  getUserRoles,
  userRole,
  createUser,
  updateUser,
  getSingleUser,
  singleUserData,
  updateUserStatus,
  deleteUser,
  setSingleUser,
  getListOfCountries,
  permissions,
  getNotificationCatalogues,
  sendNotificationEmail,
}) => {
  const [form] = Form.useForm()
  const [userData, setUserData] = useState(getCardData || [])
  const [state, setState] = useState('all')
  const [addUserDrawer, setAddUserDrawer] = useState(false)
  const tableRef = useRef(null)
  const [pageNum, setPageNum] = useState(1)
  const [searchValue, setSearchValue] = useState('')
  const [sortBy, setSortBy] = useState('')
  const [loading, setLoading] = useState(false)

  const [userRoleValue, setUserRoleValue] = useState('')
  const [userStatus, setUserStatus] = useState('')

  const [userId, setUserId] = useState('')
  const [updateLoading, setUpdateLoading] = useState(false)
  const [editTemplate, setEditTemplate] = useState(null)
  const [inActiveTemplate, setInActiveTemplate] = useState(null)
  const [activeTemplate, setActiveTemplate] = useState(null)

  const onCardClick = key => {
    setState(key)
    setUserStatus(key === 'all' ? '' : key)
    setUserRoleValue('')
    setPageNum(1)
  }

  const onClickAdd = () => {
    setAddUserDrawer(true)
    setSingleUser({})
    form.resetFields()
  }

  const getUserData = async () => {
    setLoading(true)
    try {
      await getUserList({
        searchValue,
        sortBy,
        userRoleValue,
        userStatus,
        pageNum,
      })
    } catch (err) {
      //
    } finally {
      setTimeout(() => {
        setLoading(false)
      }, 1000)
    }
  }

  const getSingleUserInfo = async userId => {
    setUpdateLoading(true)
    await getSingleUser({ userId })
    setUpdateLoading(false)
  }

  useEffect(() => {
    getUserRoles()
  }, [])

  useEffect(() => {
    getUserMetrics()
  }, [userList])

  useEffect(() => {
    getUserData()
  }, [pageNum, searchValue, sortBy, state])
  useEffect(() => {
    tableRef.current.scrollIntoView({
      behavior: 'smooth',
    })
  }, [pageNum])

  useEffect(() => {
    let response = getCardData(userMetrics)
    setUserData(response)
  }, [userMetrics])

  const cruds = permittedCruds(permissions, 'Users')

  const permittedEvents = permittedEventCruds(permissions, 'USERS')
  const Edit =
    permittedEvents?.find(item => item.events?.eventName === 'EDIT')?.events ||
    ''
  const InActive =
    permittedEvents?.find(item => item.events?.eventName === 'ACTIVE/INACTIVE')
      ?.events || ''
  const Active =
    permittedEvents?.find(item => item.events?.eventName === 'ACTIVE/INACTIVE')
      ?.events || ''
  useEffect(() => {
    ;(async () => {
      if (Edit?.id) {
        let responce = await getNotificationCatalogues(Edit?.id)
        const filteredArray = responce?.CatalogueData?.filter(
          item =>
            item.eventNotificationTemplate &&
            item.eventNotificationTemplate.templateName ===
              'User Role updation' &&
            item.eventNotificationTemplate.eventNotificationType &&
            item.eventNotificationTemplate.eventNotificationType.name ===
              'E-Mail'
        )

        if (filteredArray?.length > 0) {
          setEditTemplate(filteredArray[0].eventNotificationTemplate)
        }
      }
    })()

    return () => {}
  }, [Edit])

  useEffect(() => {
    ;(async () => {
      if (InActive?.id) {
        let responce = await getNotificationCatalogues(InActive?.id)
        const filteredArray = responce?.CatalogueData?.filter(
          item =>
            item.eventNotificationTemplate &&
            item.eventNotificationTemplate.templateName === 'User InActive' &&
            item.eventNotificationTemplate.eventNotificationType &&
            item.eventNotificationTemplate.eventNotificationType.name ===
              'E-Mail'
        )

        if (filteredArray?.length > 0) {
          setInActiveTemplate(filteredArray[0].eventNotificationTemplate)
        }
      }
    })()

    return () => {}
  }, [InActive])
  useEffect(() => {
    ;(async () => {
      if (Active?.id) {
        let responce = await getNotificationCatalogues(Active?.id)
        const filteredArray = responce?.CatalogueData?.filter(
          item =>
            item.eventNotificationTemplate &&
            item.eventNotificationTemplate.templateName === 'User Activation' &&
            item.eventNotificationTemplate.eventNotificationType &&
            item.eventNotificationTemplate.eventNotificationType.name ===
              'E-Mail'
        )

        if (filteredArray?.length > 0) {
          setActiveTemplate(filteredArray[0].eventNotificationTemplate)
        }
      }
    })()

    return () => {}
  }, [Active])
  return (
    <>
      <SectionWrapper column>
        <PaddedDiv column>
          <TopHeader row spaceBetween alignCenter ref={tableRef}>
            <TopHeading flexStart>Users</TopHeading>
            {cruds?.includes('ADD USER') && (
              <Button.Primary
                height={'38px'}
                text={'Add User'}
                icon={<PlusIcon />}
                onClick={onClickAdd}
              />
            )}
          </TopHeader>

          <CardRow>
            {userData?.map(card => (
              <InfoCards
                key={card?.key}
                width={'25%'}
                height="130px"
                icon={card?.icon}
                text={card?.text}
                value={card?.value}
                state={card?.state}
                current={state}
                onClick={() => onCardClick(card?.state)}
              />
            ))}
          </CardRow>
        </PaddedDiv>

        <UsersFilter
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          userRole={userRole}
          userRoleValue={userRoleValue}
          setUserRoleValue={setUserRoleValue}
          userStatus={userStatus}
          setUserStatus={setUserStatus}
          getUserData={getUserData}
          setState={setState}
          userList={userList}
        />

        <UsersTable
          permittedCruds={cruds}
          userList={userList}
          userRole={userRole}
          setSortBy={setSortBy}
          loading={loading}
          getSingleUserInfo={getSingleUserInfo}
          singleUserData={singleUserData}
          setAddUserDrawer={setAddUserDrawer}
          setUserId={setUserId}
          updateUserStatus={updateUserStatus}
          deleteUser={deleteUser}
          setPageNum={setPageNum}
          getUserData={getUserData}
          pageNum={pageNum}
          updateLoading={updateLoading}
          inActiveTemplate={inActiveTemplate}
          activeTemplate={activeTemplate}
          sendNotificationEmail={sendNotificationEmail}
        />
      </SectionWrapper>

      <AddUserDrawer
        addUserDrawer={addUserDrawer}
        setAddUserDrawer={setAddUserDrawer}
        userRole={userRole}
        createUser={createUser}
        updateUser={updateUser}
        singleUserData={singleUserData}
        userId={userId}
        getUserData={getUserData}
        onClickAdd={onClickAdd}
        form={form}
        updateLoading={updateLoading}
        getListOfCountries={getListOfCountries}
        editTemplate={editTemplate}
        sendNotificationEmail={sendNotificationEmail}
      />
    </>
  )
}

export default Users
